<div class="overlay-background" *ngIf="show"></div>
<div class="overlay-content-wrapper" *ngIf="show">
	<div class="overlay-content" aria-live="assertive">
		<a class="close" (click)="cancel()" (keydown.space)="cancel()" tabindex="0"><i class="twingle-X"></i></a>
		<h2>{{'overlay.' + name + '.headline' | translate}}</h2>
		<p [innerHTML]="'overlay.' + name + '.text' | translate"></p>
  <button #submitButton class="button primary" (click)="submit()">{{'overlay.' + name + '.button' | translate}}</button>
		<div class="text-center">
			<a (click)="cancel()" (keydown.space)="cancel()" tabindex="0">{{'overlay.cancel.headline' | translate}}</a>
		</div>
	</div>
</div>
